exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Qc0Q3lBw_vMEvKBLqK6I-{width:310px}.OYlpDCKfEQGWBhZixTJ9r{width:450px!important;max-width:500px!important}.TtSmCuXCUVyV_MRjO6Kjf{color:var(--themePrimary)}.VA3WS-BMFZRR1NdzVNpmp{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._2BxhunX1FleHdC6R8je9mh{border-radius:4px}@media screen and (max-width:450px){html[dir] ._39ocw8iX1tcEw46G82sClD>div{text-align:start}}", ""]);
// Exports
exports.locals = {
	"fixWidthContextMenuAdvanced": "_3Qc0Q3lBw_vMEvKBLqK6I-",
	"fixWidthContextMenuSuggestion": "OYlpDCKfEQGWBhZixTJ9r",
	"unscheduleText": "TtSmCuXCUVyV_MRjO6Kjf",
	"innerContent": "VA3WS-BMFZRR1NdzVNpmp",
	"buttonRadii": "_2BxhunX1FleHdC6R8je9mh",
	"footer": "_39ocw8iX1tcEw46G82sClD"
};